export default __webpack_public_path__ + "static/media/laptop.e8aa562c.png";